import type { IconSvgObject } from './types';

const AdobePremierIcon: IconSvgObject = [
  ["path", { d: "M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 16V12M7 12V8H9C10.1046 8 11 8.89543 11 10C11 11.1046 10.1046 12 9 12H7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 10.5V12.5M14 12.5V16M14 12.5C15.5 10 17.5 11 17.5 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AdobePremierIcon;
